import { useEffect } from "react";

/**
 * Privacy Policy redirect page
 * Immediately redirects to the main Swirl privacy policy
 */
const PrivacyPolicy = () => {
  useEffect(() => {
    window.location.href = "https://swirlapp.ai/privacy";
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900">
      <div className="text-center">
        <div className="animate-spin rounded-full h-10 w-10 border-2 border-white/20 border-t-white mx-auto mb-4"></div>
        <p className="text-white/70 text-sm">Redirecting to privacy policy...</p>
        <a 
          href="https://swirlapp.ai/privacy" 
          className="text-purple-300 hover:text-purple-200 text-xs mt-2 inline-block underline"
        >
          Click here if not redirected
        </a>
      </div>
    </div>
  );
};

export default PrivacyPolicy;






